import { GzRelayCommunicationWebComponent } from './component/GzRelayCommunicationWebComponent';

export { GzRelayCommunicationWebComponent };
